import Vue from "vue";
import Router from "vue-router";
import { requireAuth, isAuthed } from "@/utils/auth";
// Auth group
import Login from "@/components/auth/Login";
import Register from "@/components/auth/Register";
import Reminder from "@/components/auth/Reminder";
import Reset from "@/components/auth/Reset";

// App components
import Dashboard from "@/components/Dashboard";
import Analysis from "@/components/Analysis";
import Profile from "@/components/Profile";
import History from "@/components/History";
import Edit from "@/components/Edit";
import Terms from "@/components/Terms";

Vue.use(Router);

export default new Router({
	mode: "history",
	routes: [
		{
			path: "/",
			name: "Login",
			beforeEnter: isAuthed,
			component: Login
		},
		{
			path: "/register",
			name: "Register",
			beforeEnter: isAuthed,
			component: Register
		},
		{
			path: "/reminder",
			name: "Reminder",
			beforeEnter: isAuthed,
			component: Reminder
		},
		{
			path: "/reset",
			name: "Reset",
			beforeEnter: isAuthed,
			component: Reset
		},
		{
			path: "/profile",
			name: "Profile",
			beforeEnter: requireAuth,
			component: Profile
		},
		{
			path: "/dashboard",
			name: "Dashboard",
			beforeEnter: requireAuth,
			component: Dashboard
		},
		{
			path: "/analysis",
			name: "Analysis",
			beforeEnter: requireAuth,
			component: Analysis
		},
		{
			path: "/history",
			name: "History",
			beforeEnter: requireAuth,
			component: History
		},
		{
			path: "/history/:id",
			name: "edit-entry",
			beforeEnter: requireAuth,
			component: Edit
		},
		{
			path: "/terms-conditions",
			name: "Terms",
			component: Terms
		},
		{
			path: "*",
			name: "404",
			component: {
				template:
					"<div><h1>404</h1><hr><p>Sorry, this page does not exist.</p></div>"
			}
		}
	]
});



// WEBPACK FOOTER //
// ./src/router/index.js